import axios from 'axios'
let instance = axios.create();
import store from '@/store'
import { showToast } from 'vant'
// 判断是否是微信内打开的方法
const isWechat = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua);
};


// 根据环境变量判断正式环境还是测试环境
const isProd = process.env.NODE_ENV === 'production';
instance.defaults.baseURL = isProd ? 'https://m.voc.com.cn' : '/growth';
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
     let time = new Date().getTime();
    config.headers = {
        ...config.headers,
        'RMT-Device-Type':'web',
        'RMT-Auth':store.state.userInfo.token,
        'RMT-Device-Id':(store.state.userInfo.info&&store.state.userInfo.info.deviceid)?store.state.userInfo.info.deviceid:'',
        'RMT-Request-Time': time + '',
    }
    if(store.state.is_wechat&&config.data){
        config.data['RMT-From'] = 'Wechat'
    }
    if(store.state.userInfo.appid&&config.data){
        config.data['appid'] = store.state.userInfo.appid
    }
    if(store.state.userInfo.appid&&config.params){
        config.params['appid'] = store.state.userInfo.appid
    }
    if(store.state.is_wechat&&config.params){
        config.params['RMT-From'] = 'Wechat'
    }
     if(isWechat()&&config.data){
        config.data['RMT-From'] = 'Wechat'
    }
    if(isWechat()&&config.params){
        config.params['RMT-From'] = 'Wechat'
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    if(response.data.statecode == 1){
        return response
    }else{
        showToast({
            message:response.data.message,
            duration:1000
        })
        return false
    }
    // 对响应数据做点什么  
}, function (error) {
    // 对响应错误做点什么
    console.log('--- 401 res error response ---')
    console.log(error)
    return Promise.reject(error)
})
export default instance